import { PropsWithChildren } from 'react';

export const MobilePagesLayout = ({ children }: PropsWithChildren) => {
  return <div className="mx-auto flex max-w-[640px] flex-col">{children}</div>;
};
